import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBeatVIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.0667 2H2.93333C2.41787 2 2 2.41787 2 2.93333V15.0667C2 15.5821 2.41787 16 2.93333 16H15.0667C15.5821 16 16 15.5821 16 15.0667V2.93333C16 2.41787 15.5821 2 15.0667 2Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7 5.5L9 12.5L11 5.5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgBeatVIcon;
